import CourseCard from './CourseCard.vue';
import Live from './Live.vue';
import { Empty } from 'zhs-components';
import { ArrowRight, ArrowDown } from '@element-plus/icons-vue';
import CommonTitle from './CommonTitle.vue';
import { getStorage } from '@/plugins/store';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import SwiperCore, { Navigation, A11y, Autoplay } from 'swiper';
SwiperCore.use([Navigation, A11y, Autoplay]);
import 'swiper/swiper-bundle.min.css';
export default {
  components: {
    CourseCard,
    Live,
    Empty,
    ArrowRight,
    ArrowDown,
    CommonTitle,
    Swiper,
    SwiperSlide
  },

  setup() {
    const swiperInstance = ref(null);

    const setStyle = () => {
      if (!swiperInstance.value) return;
      const slides = swiperInstance.value.slides;
      slides.forEach((slideEl, index) => {
        const progress = slides[index].progress; // console.log(progress)

        Object.assign(slideEl.style, {
          opacity: '',
          background: '',
          transform: ''
        });
        slideEl.style.transform = `translate3d(0,${Math.abs(progress) * 40}px,0)`;
      });
    };

    const onSwiper = swiper => {
      swiperInstance.value = swiper;
      setStyle();
    };

    const setTranslate = () => {
      setStyle();
    };

    const setTransition = transition => {
      if (!swiperInstance.value) return;
      swiperInstance.value.slides.forEach(slideEl => {
        slideEl.style.transition = transition;
      });
    };
  },

  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number || String,
      default: 0
    },
    isTop: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.getAuth();
    this.getTypeList();
  },

  watch: {
    typeId: {
      handler(val) {
        this.getHomeCourseList();
      },

      immediate: true
    }
  },

  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      classId: undefined,
      authType: 0,
      typeList: [],
      hiddenMoreClass: true,
      typeId: '',
      modules: [Navigation, A11y, Autoplay]
    };
  },

  methods: {
    async getHomeCourseList() {
      const projectBaseData = getStorage('projectBaseData') || {};
      const homeCourse = await this.$http.getSmartCourseListHome({
        // num: this.menu.num,
        '_pageable.page': 0,
        '_pageable.size': 999,
        menu_id: this.menu.menu_id,
        classify_id: this.typeId,
        order: 1,
        schoolId: projectBaseData.school_id
      });
      console.log(11122233, homeCourse.content);
      this.homeCourseList = homeCourse.content;
    },

    async getAuth() {
      const res2 = await this.$http.getConfigList();
      this.authType = res2.find(item => item.code == '11902') ? res2.find(item => item.code == '11902').auth_type : 0;
    },

    async getTypeList() {
      const res = await this.$http.getCourseType({
        menu_id: this.menu.menu_id
      });
      this.typeList = res;
    },

    searchCourseList(id) {
      this.typeId = id;
    },

    handleMore() {
      let navItemInfo = JSON.parse(sessionStorage.getItem('authInfo'));
      let nav = navItemInfo.find(item => item.function_id == '18300');

      if (nav) {
        window.location.href = `/teacherList.html?menuId=${nav.id}&name=${nav.nav_name}&tab=${this.menu.menu_id}`;
      }
    }

  }
};